import { Typography } from "@/react/components/shared/uikit/Typography";
import type { HelpWidgetMessage } from "../../types/help_widget_message";

export const ChatDivider = ({ message }: { message: HelpWidgetMessage }) => (
  <div className="mx-4 flex items-center">
    <div className="h-px grow bg-gray-200 dark:bg-gray-700" />
    <div className="mx-5 grow-0 uppercase">
      <Typography.LabelXxs color="text-disabled" weight="bold">
        {message.content}
      </Typography.LabelXxs>
    </div>
    <div className="h-px grow bg-gray-200 dark:bg-gray-700" />
  </div>
);
